import authService from './auth-service';
import patientService from './patient-service';
import organisationService from './organisation-service';
import positionService from './position-service';
import staffService from './staff-service';
import roleService from './role-service';
import packageService from './package-service';
import onlineServiceService from './online-service';
import bookingService from './booking-service';
import fittestBookingService from './fittest-booking-service';
import paperworkService from './paperwork-service';
import preferredSiteService from './preferred-site-service';
import addressBookService from './address-book-service';
import caseService from './case-service';
import projectIdentificationService from './project-identification-service';
import onsiteBookingService from './onsite-booking-service';
import consultationService from './consultation-service';
import manageLoginService from './manage-login-service';
import utilService from './util-service';

export {
  authService,
  patientService,
  organisationService,
  positionService,
  staffService,
  roleService,
  packageService,
  onlineServiceService,
  bookingService,
  fittestBookingService,
  paperworkService,
  preferredSiteService,
  addressBookService,
  caseService,
  projectIdentificationService,
  onsiteBookingService,
  consultationService,
  manageLoginService,
  utilService,
};
